import React, { Fragment, useEffect, useState, forwardRef } from "react";
import { useAuth } from "../context/AuthContext";
import AsyncSelect from "react-select/async";

const DropDownRoleSelection = forwardRef(({
  defaultValue,
  onSelected,
  placeholderText = "All Roles",
  disabled = false,
}, ref) => {
  const { authAxios } = useAuth();
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (defaultValue === null || defaultValue === undefined) return;

    setSelected({ value: defaultValue, label: defaultValue });
  }, [defaultValue]);

  const fetchRoles = async () => {
    try {
      const response = await authAxios().get("/api/roles/");
      
      const data = response.data.map((role) => {
        return { value: role, label: role };
      });

      return data;
    } catch (error) {
      console.log("Error catch");
      console.log(error);
      console.log(error.stack);
    }
    return [];
  };

  const selectRole = (roleOption) => {
    setSelected(roleOption);
    onSelected(roleOption?.value);
  };

  const promiseOptions = () =>
    new Promise((resolve) => {
      setTimeout(() => {
        resolve(fetchRoles());
      }, 500);
    });

  // Expose methods to the parent component via ref
  React.useImperativeHandle(ref, () => ({
    reset: () => {
      setSelected(null);
      onSelected(null);
    }
  }));

  return (
    <Fragment>
      <AsyncSelect
        className={"fs-input"}
        cacheOptions
        loadOptions={promiseOptions}
        defaultOptions={true}
        isClearable={true}
        onChange={(data) => {
          selectRole(data);
        }}
        value={selected}
        placeholder={placeholderText}
        isDisabled={disabled}
      />
    </Fragment>
  );
});

export default DropDownRoleSelection;
